export default __webpack_public_path__ + "static/media/bannerOuvidoria.ac05e149.svg";